var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';









const ToggleButton = ({
  children,
  onToggle,
  value,
  disabled,
  className = ''
}) => {
  const checkedColor = disabled ? 'peer-checked:bg-primary-300' : 'peer-checked:bg-primary-600';
  return /*#__PURE__*/(
    _jsx("label", { className: "relative inline-flex items-center cursor-pointer" }, void 0, /*#__PURE__*/
    _jsx("input", {
      type: "checkbox",
      value: value,
      className: `${className} sr-only peer`,
      disabled: disabled,
      onChange: onToggle,
      "data-testid": "toggle" }
    ), /*#__PURE__*/
    _jsx("div", {
      className: `${checkedColor}  ${className} w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full
        peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px]
        after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all` }
    ),
    children
    ));

};



export { ToggleButton };